import PersonAddDisabledIcon from '@material-ui/icons/PersonAddDisabled';
import Blacklist from './Blacklist';

export const Blacklists: object = {
  list: Blacklist,
  icon: PersonAddDisabledIcon,
};

export default Blacklists;
